module.exports = __webpack_public_path__ + "static/export-3a5f9a2e63491debc8ff379a3f219d78.svg";